import PropTypes from "prop-types";
import { Col, Row } from "react-grid-system";
import { StyledProfileDetailsData } from "../../styles/StyledProfileDetails/StyledProfileDetailsData";
import ProfileDetailsDataEditForm from "./ProfileDetailsDataEditForm";

export default function ProfileDetailsDataEdit({ data, isEditMode, setIsEditMode }) {
	return (
		<StyledProfileDetailsData>
			<Row>
				<Col sm={12}>
					<h2>Personal data</h2>
				</Col>
			</Row>
			<ProfileDetailsDataEditForm data={data} isEditMode={isEditMode} setIsEditMode={setIsEditMode} />
		</StyledProfileDetailsData>
	);
}

ProfileDetailsDataEdit.propTypes = {
	data: PropTypes.object,
	isEditMode: PropTypes.bool,
	setIsEditMode: PropTypes.func,
};
